(function () {

  'use strict';

  function pxDestinationMicrosoftSharePointOnline(RegexModel) {
    return {
      restrict: 'E',
      scope: {
        me: '=',
        tenant: '=',
        workflowForm: '=',
        workflowFormModel: '=',
        fileNameShorthands: '=',
        fileNameFormModel: '=',
        filePathFormModel_SHAREPOINT: '=filePathFormModelSharepoint'
      },
      templateUrl: 'app/components/settings/workflows/workflowProperties/destination/microsoftSharePointOnline/destinationMicrosoftSharePointOnline.template.html',
      link: function (scope, element, attrs) {

        scope.BAD_FILE_NAME = new RegexModel().badNameString_variables().string;
        scope.BAD_PATH_STRING = new RegexModel().badPathString_variables().string;

      }
    };
  }

  pxDestinationMicrosoftSharePointOnline.$inject = ['RegexModel'];

  angular
    .module('printix-admin')
    .directive('pxDestinationMicrosoftSharePointOnline', pxDestinationMicrosoftSharePointOnline);

})();
